export interface Product {
    itemId?: number;
    itemBarcode: string;
    itemName: string;
    itemPrice: number;
    itemPriceAdjustment?: number;
    itemNumber: string;
    manageSN?: boolean;
    hasSerialNumber?: boolean;
    serialNumber?: string | null;
    warehouseId?: number;
    warehouseName?: string;
    quantity?: number;
    createDate?: string;
    expiredDate?: string;
    printQty?: number
}

export interface PriceCategory {
    name: string;
}

export interface SerialNumberItem {
    serialNumber: string;
    warehouseId?: number;
    warehouseName?: string;
    quantity?: number;
    createDate?: string;
    expiredDate?: string;
}

export interface ProductGroup {
    item: Product;
    children: Product[];
}

export const getProductBarcode = (product: Product): string =>
    product.serialNumber?.trim() || product.itemBarcode;

export const mergeSerialProducts = (
    products: Product[],
    item: Product,
    serialNumbers: SerialNumberItem[],
): Product[] => {
    const existingSerialNumbers = new Set(
        products
            .filter((product) => product.itemNumber === item.itemNumber)
            .map((product) => product.serialNumber?.trim())
            .filter(Boolean),
    );

    const additions = serialNumbers
        .filter((serial) => {
            const value = serial.serialNumber.trim();
            if (!value || existingSerialNumbers.has(value)) return false;
            existingSerialNumbers.add(value);
            return true;
        })
        .map((serial) => ({
            ...item,
            serialNumber: serial.serialNumber,
            warehouseId: serial.warehouseId,
            warehouseName: serial.warehouseName,
            quantity: serial.quantity,
            createDate: serial.createDate,
            expiredDate: serial.expiredDate,
            printQty: undefined,
        }));

    return [...products, ...additions];
};
